import { render, staticRenderFns } from "./FullVideoSwiper.vue?vue&type=template&id=c9dcbaee&scoped=true&"
import script from "./FullVideoSwiper.vue?vue&type=script&lang=js&"
export * from "./FullVideoSwiper.vue?vue&type=script&lang=js&"
import style0 from "./FullVideoSwiper.vue?vue&type=style&index=0&id=c9dcbaee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dcbaee",
  null
  
)

export default component.exports